import React, { useEffect, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TableSpecialist from "./TableSpecialist/TableSpecialist";
import { useDispatch, useSelector } from "react-redux";
import { handleError } from "../../utils/handleError";
import toast from "react-hot-toast";
import { gettAllSpecialist } from "../../services/users/userService";
import { setListSpecialist } from "../../redux/slice/usersSlice";
import Loading from "../../components/Loading/Loading";
import PieGraphicSpecialist from "./PiegraphicSpecialist";
import BarChartSpecialist from "./BarChartSpecialist";
import CreateSpecialistModal from "./ModalCreateSpecialist";

const Specialist = () => {
  const [loading, setLoading] = useState(true);
  const { listSpecialist } = useSelector((state) => state.usersReducer);
  const [showModalUser, setShowModalUser] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    const getListServiceProvider = async () => {
      try {
        const listSpecialist = await gettAllSpecialist();
        // console.log("lista de especialistas", listSpecialist);
        dispatch(setListSpecialist({ listSpecialist: listSpecialist }));
        setLoading(false);
      } catch (error) {
        setListSpecialist({ listSpecialist: [] });
        const { message } = handleError(error);
        setLoading(false);
        toast.error(`No se pudieron obtener los especialistas. \n ${message}`);
      }
    };
    getListServiceProvider();
  }, [dispatch]);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Loading loading={loading} />
      <CreateSpecialistModal
        open={showModalUser}
        setOpen={setShowModalUser}
        setLoading={setLoading}
      />

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Typography variant="h5">Especialistas</Typography>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          startIcon={<PersonAddIcon />}
          onClick={() => {
            setShowModalUser(true);
          }}
        >
          Agregar especialista
        </Button>
      </Box>

      <TableSpecialist setLoading={setLoading} rows={listSpecialist ?? []} />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          flexWrap: "wrap",
          justifyContent: "space-around",
          gap: 4,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Tipo de especialidad</Typography>
          <PieGraphicSpecialist />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography variant="h5">Estatus de las cuentas</Typography>

          <BarChartSpecialist />
        </Box>
      </Box>
    </Box>
  );
};

export default Specialist;
